import React from "react";

import "../../../Env.css";
import "./SpecManager.css";
import "./SpecTable.css";
import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";

import { ReactComponent as QualitativeIcon } from "../../../../../assets/images/product/QualitativeIcon.svg";
import { ReactComponent as QuantitativeIcon } from "../../../../../assets/images/product/QuantitativeIcon.svg";
import { ReactComponent as RangeIcon } from "../../../../../assets/images/product/RangeIcon.svg";

class SpecTable extends React.Component {
  static getFormattedSpec(specs, testType) {
    let units = specs[2];
    let min = specs[0];
    let max = specs[1];

    if (units === undefined) units = "";
    if (min === undefined) min = "";
    if (max === undefined) max = "";

    if (testType === "quantitative") {
      return `${max} ${units}`;
    }

    if (testType === "range") {
      return `${min} - ${max} ${units}`;
    }

    if (testType === "qualitative") {
      let value = specs[1];
      if (value === undefined) {
        value = "";
      }
      return `${min} ${value} ${units}`;
    }

    return `${min} ${max} ${units}`;
  }

  static getFormattedTestType(testType) {
    const formattedTestType = testType.charAt(0).toUpperCase() + testType.substring(1, testType.length);

    if (testType === "quantitative") {
      return (
        <div className="SpecTable__TestType">
          <QuantitativeIcon />
          <span>{formattedTestType}</span>
        </div>
      );
    }

    if (testType === "qualitative") {
      return (
        <div className="SpecTable__TestType">
          <QualitativeIcon />
          <span>{formattedTestType}</span>
        </div>
      );
    }

    if (testType === "range") {
      return (
        <div className="SpecTable__TestType">
          <RangeIcon />
          <span>{formattedTestType}</span>
        </div>
      );
    }

    return <span>{testType}</span>;
  }

  renderTests() {
    const { dataOfSpecEditing } = this.props;

    return (
      dataOfSpecEditing.map((item, index) => (
        <tr key={index}>
          <td
            style={{
              textAlign: "center",
              border: "1px solid #E1E1E1",
              borderRadius: "3px",
            }}
          >
            {/* {item.Test}  */}
            {item.test}
          </td>

          <td
            style={{
              textAlign: "center",
              border: "1px solid #E1E1E1",
              borderRadius: "3px",
              color: "#375393",
            }}
          >
            {/* {item.Test}  */}
            {SpecTable.getFormattedTestType(item.test_type)}
          </td>

          <td
            style={{
              textAlign: "center",
              border: "1px solid #E1E1E1",
              borderRadius: "3px",
              color: "#375393",
            }}
          >
            {SpecTable.getFormattedSpec(item.specs, item.test_type)}
          </td>

        </tr>
      ))
    );
  }

  render() {
    return (
      <StyledScrollbar
        disableTrackYWidthCompensation
        disableTracksWidthCompensation
        style={{
          position: "",
          width: "100%",
          height: "350px",
          minHeight: "350px",
        }}
        id="specManagerSpecTableScrollBar"
      >
        <table className="envSpecTable" style={{ paddingRight: "10px" }}>
          <thead>
            <tr>
              <th className="envSpecManagerEditSpecTh1">Test</th>
              <th className="envSpecManagerEditSpecTh2">Test Type</th>
              <th className="envSpecManagerEditSpecTh3">Specs</th>
            </tr>
          </thead>
          <tbody>
            {this.renderTests()}
          </tbody>
        </table>
      </StyledScrollbar>
    );
  }
}

export default SpecTable;
